import * as React from 'react';
import {FC, useState} from 'react';
import Modal from 'react-bootstrap/Modal';
import ReactCrop, {Crop} from 'react-image-crop';
import Button from 'react-bootstrap/Button';
import 'react-image-crop/dist/ReactCrop.css';



const getCroppedImage = (image,crop,imageName) => {
  const canvas = document.createElement('canvas');
  const scaleX = image.naturalWidth / image.width;
  const scaleY = image.naturalHeight / image.height;
  // @ts-ignore
  canvas.width = crop.width;
  // @ts-ignore
  canvas.height = crop.height;
  const ctx = canvas.getContext('2d');
  // @ts-ignore
  ctx.drawImage(image, crop.x * scaleX, crop.y * scaleY, crop.width * scaleX, crop.height * scaleY, 0, 0, crop.width, crop.height,);
  return canvas.toDataURL('image/jpeg');
}

export const ImageCropModal  = props => {
  const initialCrop = {
    aspect: 1,
    unit: 'px',
    width: 200,
    height: 200
  };

  const [crop,
    setCrop] = useState(initialCrop);

  const handleCropImage = () => {
    const img = document.querySelector('img.ReactCrop__image');
    const CroppedImagePath = getCroppedImage(img, crop, 'test');
    props.onCropSelected(CroppedImagePath);
  };

  return (
    <Modal
      show={props.isVisible}
      onHide={props.handleHide}
      aria-labelledby='contained-modal-title-center'
      centered
      dialogClassName='image-crop-dialog'>
      <Modal.Body>
        <ReactCrop
          src={props.imagePath}
          crop={crop}
          onChange={newCrop => setCrop(newCrop)}/>
      </Modal.Body>
      <div
        className='transaction-controls mt-2 mb-4 d-flex flex-column flex-sm-row justify-content-center align-items-center'>
        <Button
          onClick={() => props.handleHide()}
          size='sm'
          className='mx-sm-2 mb-3 mb-sm-0 control-btn'
          variant='outline-primary'>Cancel</Button>
        <Button
          style={{backgroundColor: '#0C8444'}}
          size='sm'
          className='mx-sm-2 control-btn'
          variant='primary'
          onClick={() => handleCropImage()}>
          Select image</Button>
      </div>
    </Modal>
  );
};

export default ImageCropModal;